<template>
  <div id="app">
    <div>
      <b-navbar toggleable="lg" type="light" variant="info">
        <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
        <b-collapse is-nav id="nav_dropdown_collapse">
          <b-navbar-nav>
            <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/App.vue" target="_blank" style="color:black">
              <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
            </a>
            <b-nav-item style="font-weight:600;" v-bind:active="$route.name === 'Home'" href="/frb-web" v-if="isLogged === true">
              <b-icon icon="house" aria-hidden="true"></b-icon>
              Home
            </b-nav-item>
            <b-nav-item style="font-weight:600;" v-bind:active="['Admin', 'ManageTeams'].includes($route.name)" href="/frb-web/admin" v-if="isLogged === true">
              <b-icon icon="emoji-angry" aria-hidden="true"></b-icon>
              Admin
            </b-nav-item>
            <b-nav-item style="font-weight:600;" v-bind:active="['Analysis', 'analysisVerification', 'analysisCandidates', 'pipelineExperts'].includes($route.name)" href="/frb-web/analysis-verification" v-if="isLogged === true">
              <b-icon icon="emoji-dizzy" aria-hidden="true"></b-icon>
              Analysis
            </b-nav-item>
            <b-nav-item style="font-weight:600;" v-bind:active="['ScienceCandidates', 'PipelineSummary', 'ScienceCatalog'].includes($route.name)" href="/frb-web/science-candidates" v-if="isLogged === true">
              <b-icon icon="emoji-smile" aria-hidden="true"></b-icon>
              Science
            </b-nav-item>
            <b-nav-item style="font-weight:600;" v-bind:active="$route.name === 'notWiki'" href="/frb-web/notWiki" v-if="isLogged === true">
              <b-icon icon="emoji-heart-eyes" style="color: yellow" aria-hidden="true"></b-icon>
              <span style="color: yellow">Not Wiki</span>
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="mr-auto">
          </b-navbar-nav>
          <b-navbar-nav class="mr-auto">
          </b-navbar-nav>
          <b-navbar-nav class="mr-auto">
          </b-navbar-nav>
          <b-navbar-nav class="mr-auto">
            <b-nav-item style="font-weight:600;" href="/frb-web/outrigger-home" v-if="isLogged === true">
              <b-icon icon="binoculars" aria-hidden="true"></b-icon>
              Outriggers
            </b-nav-item>
            <b-nav-item style="font-weight:600;" v-bind:active="$route.name === 'Login'" href="/frb-web/login" v-if="isLogged === false">
              <b-icon icon="person-fill" aria-hidden="true"></b-icon> Login
            </b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'Logout'" @click.prevent="logout" v-if="isLogged === true">
              <b-icon icon="power" aria-hidden="true"></b-icon>
              Logout
          </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <!--<label class="mr-sm-2" for="userName"> Who are you? </label>
      <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                     :value="null"
                     :options="users"
                     @change.native="changeUser"
                     id="userName">
      </b-form-select>-->
    </div>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from './components/AppFooter.vue'
import { bus } from './main'
export default {
  name: 'App',
  components: {
    AppFooter
  },
  data () {
    return {
      users: [],
      isLogged: false
    }
  },
  created () {
    this.checkIfIsLogged()
    bus.$on('logged', () => {
      this.checkIfIsLogged()
      this.isLogged = true// this.isLogged
    })
  },
  methods: {
    logout () {
      delete (localStorage.accessToken)
      delete (localStorage.refreshToken)
      delete (localStorage.accessTime)
      delete (localStorage.username)
      delete (localStorage.isLogged)
      this.checkIfIsLogged()
      this.$router.push('/frb-web/login')
    },
    async checkIfIsLogged () {
      let token = localStorage.isLogged
      this.isLogged = false
      if (token) {
        this.isLogged = true
      }
      /* console.log("App.vue: ", token)
      if (token) {
        var url = 'https://frb.chimenet.ca/frb-master/auth/verify'
        var authHeaders = {'Authorization': 'Bearer ' + localStorage.accessToken}
        this.$http.get(url, {headers: authHeaders})
          .then(user => {
            console.log('app vue authenticated with ')
            console.log(localStorage.accessToken)
            this.isLogged = true
          }, user => {
            console.log('tried ... but ... authentication did not work in app vue')
            this.isLogged = false
          })
      } else {
        this.isLogged = false
      } */
      console.log(this.isLogged)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue